import { Styles } from 'jss';

import { commonStyles } from '../../assets/styles/common.styles';
import { styles } from '../../assets/styles/styles';
import { AdSlot } from '../../entities/ad-slot';
import { StylesDataType } from '../../types';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class StylesheetProvider {
  public provide (adSlot: AdSlot): Styles<string, StylesDataType> {
    // Common styles are always applied and overridden by creative type-specific styles

    return {
      ...commonStyles,
      ...styles[adSlot.getCreativeType()] ?? {},
    };
  }
}
